// Modules
import * as Yup from 'yup'

// Application
import { passwordValidator } from 'utils'

export const NewPasswordSchema = Yup.object().shape({
    newPassword: Yup.string()
        .required('Campo obrigatório')
        .test('newPassword', ' Senha inválida', (value: string): boolean => {
            const obj = passwordValidator(value)
            return Object.values(obj).every((itemValue: boolean) => itemValue)
        }),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'As senhas não conferem')
        .required(' '),
})
